import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { Link } from 'react-router'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { TaskApprove } from 'containers/forms/tasks'
import { Table, Data } from 'components/layout/Table'
import { Button, ButtonGroup } from 'components/misc'
import { AssessorDetailModal } from 'components/modals'
import MODALS from 'constants/modals'

import { tasks as tasksLayout } from 'constants/layout'
import {
  apiConfiguration,
  apiCommon,
  apiCodeLists,
  apiTasksRegistrationParticipants,
  apiParticipants,
  apiAwards,
  apiTasksAssessors
} from 'helpers/decorators/api'
import { modal, notification } from 'redux/modules/app'
import { meta, tableCommon } from 'helpers/decorators'
import TaskAssessorEdit from '../../forms/tasks/TaskAssessorEdit/TaskAssessorEdit'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { Link } from 'react-router-dom'
import config from '../../../config'

@meta({
  title: 'Tasks - Assessor Registration',
  intlKey: 'pageTitle.tasks_assessors_registration'
})
@apiConfiguration({
  getValues: [
    CONFIGURATION_KEYS.manageAssessors.id
  ],
  inOrganizationDetail: true
})
@apiCommon({
  countries: true,
})
@apiCodeLists(['titles', 'phoneTypes', 'assessorReasonsOfDeletionTypes'])
@apiTasksRegistrationParticipants({
  participants: true
})
@apiParticipants({
  updateTasks: true
})
@apiTasksAssessors({
  assessorTasks: true,
  updateTasks: true,
  useCommonLimit: true
})
@apiAwards({
  updateRegistrationTasks: true
})
@tableCommon()
@connect(null, { modal, notification })
class TasksAssessors extends Component {
  static propTypes = {
    tasksAssessors: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    setAssessorTasksParams: PropTypes.func,
    onApproveAssessorRegistration: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    configuration: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    onDeleteAssessorRegistration: PropTypes.func,
    onUpdateAssessorRegistration: PropTypes.func,
  }

  state = {
    asessorRegistrationId: null,
    assessorRegistration: null
  }

  key = uuid.v1()

  handleEditModal = assessorRegistration => {
    this.setState({ assessorRegistration }, () => {
      this.props.modal(MODALS.ASSESSOR_REGISTRATION_EDIT)
    })
  }

  handleApproveModal = asessorRegistrationId => {
    this.setState({ asessorRegistrationId }, () => {
        this.props.modal(`modal-approve-${this.key}`)
    })
  }

  handleReturnModal = asessorRegistrationId => {
    this.setState({ asessorRegistrationId }, () => {
        this.props.modal(`modal-return-${this.key}`)
    })
  }

  handleShowAssessorDetails = assessorRegistration => {
    this.setState({ assessorRegistration }, () => {
      this.props.modal(MODALS.ASSESSOR_REGISTRATION_DETAIL)
    })
  }

  render() {
    const {
      tasksAssessors: { loading, list, offset, limit, pages, sort },
      setAssessorTasksParams,
      onApproveAssessorRegistration,
      setCommonLimit,
      configuration,
      codeLists,
      common,
    } = this.props

    const isAssessorManagementEnabled = configuration && configuration.values[CONFIGURATION_KEYS.manageAssessors.id]?.booleanValue

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.assessorsTableLeaders}
          setParams={setAssessorTasksParams}
        >

          <Data>
            {list.map(({ assessorRegistration, id }) => (

              <tr key={id}>
                <td>
                  <span
                    className="link"
                    onClick={() =>
                      this.handleShowAssessorDetails(assessorRegistration)
                    }
                  >
                    {get(assessorRegistration, 'id')}
                  </span>
                </td>
                <td>{get(assessorRegistration, 'firstName')}</td>
                <td>{get(assessorRegistration, 'lastName')}</td>
                <td>
                  <FormattedDate
                    value={get(assessorRegistration, 'createdAt')}
                  />
                </td>
                <td>{get(assessorRegistration, 'childProtectionNumber') ||
                  get(assessorRegistration, 'isApplyCPNNeeded') && <FormattedMessage
                  id="label.i_need_apply_cpn"
                  defaultMessage="I need to apply for my CPN (Assessor will need to provide WWC before they can start working with participants)"
                />}</td>
                <td>{get(assessorRegistration, 'assessorWWCExemptionReason') || '---'}</td>
                <td>
                  <span>
                    {get(assessorRegistration, 'invitedBy.firstName') || '---'}{' '}
                    {get(assessorRegistration, 'invitedBy.lastName') || '---'}
                    <br />
                    {get(assessorRegistration, 'invitedBy.participantDetail.id') ?
                    <Link to={`${config.publicPath}/participants/${get(assessorRegistration, 'invitedBy.id')}`}>
                    {get(assessorRegistration, 'invitedBy.globalId') || '---'}
                      </Link> :
                        <FormattedMessage id="label.award_leader" defaultMessage="Award Leader" /> }
                  </span>
                </td>
                <td>
                    {get(assessorRegistration, 'assessorActivityCategoryRegistration.activityCategory.translatedName')}
                </td>
                <td>
                  {get(assessorRegistration, 'assessor.organization.name')}
                </td>
                <td>
                  <Button
                    style={{ marginLeft: 10 }}
                    onClick={() => this.handleEditModal(assessorRegistration)}
                    tiny
                    secondary
                  >
                    <FormattedMessage
                      id="button.confirm"
                      defaultMessage="Confirm"
                    />
                  </Button>
                </td>
                <td>
                  <ButtonGroup>
                    <Button
                      onClick={() =>
                        this.handleApproveModal(assessorRegistration.id)
                      }
                      tiny
                    >
                      <FormattedMessage
                        id="button.approve"
                        defaultMessage="Approve"
                      />
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id={MODALS.ASSESSOR_REGISTRATION_EDIT} customActions large>
          <TaskAssessorEdit
            registration={this.state.assessorRegistration}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            codeLists={codeLists}
            common={common}
            onEditSubmit={this.props.onUpdateAssessorRegistration}
            onDeleteSubmit={this.props.onDeleteAssessorRegistration}
          />
        </Modal>
        <Modal id={`modal-approve-${this.key}`} customActions>
          <TaskApprove
            approve={onApproveAssessorRegistration}
            id={this.state.asessorRegistrationId}
            modal={this.props.modal}
            title="Approve assessor registration"
            intlKey="tasks.approve_assessor_registration"
            isAssessorRegistrationApproval
          />
        </Modal>
        {this.state.assessorRegistration && (
          <AssessorDetailModal
            modalId={MODALS.ASSESSOR_REGISTRATION_DETAIL}
            data={this.state.assessorRegistration}
            modal={this.props.modal}
          />
        )}
      </div>
    )
  }
}

export default TasksAssessors
